import {AppState} from "..";
import {useActivityEvent} from "~/contexts/ActivityEventContext";
import {IconButton} from "@mui/material";
import {useSelector} from "react-redux";
import {Pages} from "~/bi-events/enum";
import {IconWebchat, IconWebchatClose} from "@bounce/shared/consumer/bounce-ui";
import {Colors, Tooltip} from "@bounce/shared/ui";
import {useAmplitude} from "~/contexts";
import {ChatTooltipLabel} from "./ChatTooltipLabel";
import {useWebchat} from "../useWebchat";
import {useNewDesignEnabled} from "~/new-design/hooks/useNewDesignEnabled";

export const EntryPoint = () => {
  const isNewDesignEnabled = useNewDesignEnabled();
  const {isUserInactive, stopUserInactivityTooltip, onStopUserInactivityTooltip, isPlansTooltipActive} =
    useActivityEvent();
  const {pageClickEvent} = useAmplitude();
  const {openChat} = useWebchat();
  const expanded = useSelector((state: AppState) => state.session.expanded);

  const handleChatNow = () => {
    pageClickEvent({page: Pages.CHAT_BANNER, cta: "chat_now"});
    handleWebchatClick();
  };
  const handleWebchatClick = () => {
    pageClickEvent({page: Pages.CHAT, cta: expanded ? "chat_close" : "chat_open"});
    openChat({});
    onStopUserInactivityTooltip();
  };

  const getTitle = () => {
    if (isUserInactive && !stopUserInactivityTooltip) {
      return <ChatTooltipLabel handleClick={handleChatNow} onClose={onStopUserInactivityTooltip} />;
    }
    return undefined;
  };

  if (isNewDesignEnabled) return null;

  return (
    <Tooltip
      open={isPlansTooltipActive || (isUserInactive && !stopUserInactivityTooltip)}
      title={getTitle()}
      placement={isPlansTooltipActive ? "left" : "top"}
      PopperProps={{
        style: {zIndex: 1000},
      }}
      slotProps={{
        ...(isPlansTooltipActive && {
          tooltip: {
            sx: {
              backgroundColor: Colors.primary._800,
            },
          },
          arrow: {
            sx: {
              color: Colors.primary._800,
            },
          },
        }),
      }}
    >
      <IconButton
        onClick={handleWebchatClick}
        sx={{
          height: "3.4rem",
          width: "3.4rem",
          backgroundColor: Colors.primary._800,
          transition: "background-color 0.2s",
          "&:hover": {
            backgroundColor: Colors.primary._900,
          },
          "&:focus-visible": {
            boxShadow: "0 0 0 4px rgba(2, 99, 224, 0.7)",
          },
        }}
      >
        {expanded ? <IconWebchatClose color={Colors.neon._800} /> : <IconWebchat color={Colors.neon._800} />}
      </IconButton>
    </Tooltip>
  );
};
